import { GenerateFaceRecognitionLinkInputDto } from '@starsoft/common/dto/kyc/generate-face-recognition-link-input.dto';
import { GenerateFaceRecognitionLinkOutputDto } from '@starsoft/common/dto/kyc/generate-face-recognition-link-output.dto';
import { AxiosInstance, AxiosResponse } from 'axios';

export async function fetchCreateKycFaceRecognition(
  data: GenerateFaceRecognitionLinkInputDto,
  axiosInstance: AxiosInstance,
): Promise<GenerateFaceRecognitionLinkOutputDto> {
  const response: AxiosResponse<GenerateFaceRecognitionLinkOutputDto> =
    await axiosInstance.post<GenerateFaceRecognitionLinkOutputDto>(
      '/kyc/face-recognition',
      data,
    );
  return response.data;
}
